module.exports = __webpack_public_path__ + "img/task-edit.4a2bfc15.png";